import { styled } from '@mui/material/styles';
import { Tabs as MuiTabs, Tab as MuiTab } from '@mui/material';

interface StyledTabsProps {
  indicatorPosition?: 'top' | 'bottom';
}

export const StyledTabs = styled(MuiTabs, {
  shouldForwardProp: (prop) => prop !== 'indicatorPosition',
})<StyledTabsProps>(({ theme, indicatorPosition }) => ({
  '& .MuiTabs-indicator': {
    height: 2,
    backgroundColor: theme.palette.primary.main,
    ...(indicatorPosition === 'top' && {
      top: 0,
    }),
  },
}));

export const StyledTab = styled(MuiTab)(({ theme }) => ({
  alignItems: 'flex-start',
  padding: theme.spacing(1.5, 3),
  '& span': {
    fontWeight: theme.typography.fontWeightBold,
  },
  '&.Mui-selected': {
    color: theme.palette.text.secondary,
  },
  '&:not(.Mui-selected)': {
    background: theme.palette.grey[200],
  },
}));
